import { ListingLevel } from '@deltek/specification-client/core/Models/product'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { Theme, makeStyles } from '@material-ui/core'
import useWindow from 'bpm/shared/hooks/useWindow'
import React, { FC, useEffect, useState } from 'react'
import ListingHeaderButton from '../ListingHeader/ListingHeaderButton'
import { VARIABLE_NOTES_COUNT_LABEL } from './ListingNotes.constants'
import { resetPDNStore } from './ListingNotes.store'
import ListingNotesModal from './ListingNotesModal'
import PDNColors from './PDNColors'
import usePDNFiltersHook from './hooks/usePDNFiltersHook'
import usePDNhook from './hooks/usePDNHook'

const useStyles = makeStyles((theme: Theme) => ({
    headerLabel: {
        ...theme.typography.body1,
        margin: theme.spacing(0, 0, 0.5, 0.5),
        display: 'flex',
    },
}))

type PDNButtonProps = {
    isOnEditMode: boolean
    disabled?: boolean
    listingLevel?: ListingLevel
}

const PDNButton: FC<PDNButtonProps> = ({
    disabled,
    isOnEditMode,
    listingLevel,
}) => {
    const classes = useStyles()
    const { getWindowURL } = useWindow()

    const [isNotesDialogOpen, setIsNotesDialogOpen] = useState(false)

    const { clearFilters } = usePDNFiltersHook()

    const {
        isDeltekUser,
        listingId,
        pdnData,
        totalCount = 0,
        listingId: PDNListingID,
        refetchNotes,
    } = usePDNhook()

    const handleNoteButtonClick = React.useCallback(() => {
        setIsNotesDialogOpen(true)
    }, [])

    const handleCloseNotesModal = React.useCallback(() => {
        // TODO: Set notes read
        setIsNotesDialogOpen(false)
        clearFilters?.()
    }, [clearFilters])

    useEffect(() => {
        if (!getWindowURL().includes(PDNListingID)) {
            resetPDNStore()
        }
    }, [getWindowURL, PDNListingID, resetPDNStore])

    useEffect(() => {
        // Refetch if the listingId is different from the saved Listing
        if (
            !listingId ||
            (getWindowURL().includes('product/listing') &&
                !getWindowURL().includes(listingId))
        ) {
            resetPDNStore()
            refetchNotes()
        }
    }, [listingId, getWindowURL, refetchNotes, resetPDNStore])

    useEffect(() => {
        refetchNotes()
        return () => resetPDNStore()
    }, [])

    return isDeltekUser ? (
        <>
            <GridItem wrap="nowrap">
                <span className={classes.headerLabel}>Notes</span>
                <ListingHeaderButton
                    disabled={disabled}
                    buttonKey={'notes'}
                    buttonLabel={VARIABLE_NOTES_COUNT_LABEL(
                        !disabled ? totalCount : 0
                    )}
                    isPopoverOpen={isNotesDialogOpen}
                    isOnEditMode={isDeltekUser}
                    minWidth={150}
                    customOpenClass={{
                        backgroundColor:
                            !!pdnData?.length && !disabled
                                ? PDNColors.hasUnreadNotesColor
                                : '#5E5F61',
                    }}
                    handleButtonClick={handleNoteButtonClick}
                />
            </GridItem>
            {isNotesDialogOpen && (
                <ListingNotesModal
                    isOnEditMode={isOnEditMode}
                    open={isNotesDialogOpen}
                    onClose={handleCloseNotesModal}
                    isManufacturerListing={
                        listingLevel === ListingLevel.Manufacturer
                    }
                />
            )}
        </>
    ) : (
        <></>
    )
}

export default PDNButton
